"use strict";
exports.__esModule = true;
exports.roles = void 0;
exports.roles = {
    'ecp.childCareProvider': { descriptions: ['Child Care Provider'] },
    'ecp.communityPreschool': { descriptions: ['Community Preschool'] },
    'ecp.eceap': {
        descriptions: ['Early Childhood Education and Assistance Program (ECEAP)']
    },
    'ecp.transferFromInStateEiProgram': {
        descriptions: ['Transfer from in-state EI program']
    },
    'ecp.earlyHeadStart': { descriptions: ['Early Head Start'] },
    'ecp.headStart': { descriptions: ['Head Start'] },
    'ecp.homeVisitingProgram': { descriptions: ['Home Visiting Program'] },
    'ecp.indianEarlyHeadStart': { descriptions: ['Indian Early Head Start'] },
    'ecp.indianHeadStart': { descriptions: ['Indian Head Start'] },
    'ecp.migrantHeadStart': { descriptions: ['Migrant Head Start'] },
    'ecp.outOfStateEarlyInterventionServicesProgram': {
        descriptions: ['Out of State Early Intervention Services Program']
    },
    'ecp.schoolDistrict': { descriptions: ['School District'] },
    'med.audiologist': { descriptions: ['Audiologist'] },
    'med.cdhl': {
        descriptions: ['Center for Childhood Deafness & Hearing Loss (CDHL)']
    },
    'med.ehddi': {
        descriptions: [
            'Early Hearing-loss, Detection, Diagnosis, and Intervention (EHDDI) Program',
        ]
    },
    'med.hospital': { descriptions: ['Hospital'] },
    'med.indianHealth': { descriptions: ['Indian Health'] },
    'med.mentalHealthProfessional': {
        descriptions: ['Mental Health Professional']
    },
    'med.PhysicianArnpNpNurse': {
        descriptions: ['Physician / ARNP / NP / Nurse']
    },
    'med.specialistTherapist': { descriptions: ['Specialist / Therapist'] },
    'med.wssb': {
        descriptions: ['Washington State School for the Blind (WSSB)']
    },
    'pff.parentOrLegalGuardian': { descriptions: ['Parent or Legal Guardian'] },
    'pff.friend': { descriptions: ['Friend'] },
    'pff.fosterParent': { descriptions: ['Foster Parent'] },
    'pff.familyMember': { descriptions: ['Family Member'] },
    'soc.childFindScreening': { descriptions: ['Child Find Screening'] },
    'soc.cps.far': { descriptions: ['Child Protective Services', 'FAR'] },
    'soc.cps.chet': { descriptions: ['Child Protective Services', 'CHET'] },
    'soc.cps.capta': { descriptions: ['Child Protective Services', 'CAPTA'] },
    'soc.cps.OtherCpsWorker': {
        descriptions: ['Child Protective Services', 'Other CPS Worker']
    },
    'soc.communityServiceOffice': { descriptions: ['Community Service Office'] },
    'soc.departmentOfCorrectionFacilityOrLocalCorrectionalFacility': {
        descriptions: [
            'Department of Correction Facility / local correctional facility',
        ]
    },
    'soc.daa': {
        descriptions: ['Developmental Disabilities Administration (DDA)']
    },
    'soc.firstSteps': { descriptions: ['First Steps'] },
    'soc.publicCommunityHealthAgency.cshcn': {
        descriptions: [
            'Public / Community Health Agency',
            'Children with Special Health Care Needs (CSHCN)',
        ]
    },
    'soc.publicCommunityHealthAgency.nfp': {
        descriptions: [
            'Public / Community Health Agency',
            'Nurse Family Partnership (NFP)',
        ]
    },
    'soc.publicCommunityHealthAgency.phn': {
        descriptions: [
            'Public / Community Health Agency',
            'Public Health Nurse (PHN)',
        ]
    },
    'soc.substanceAbuseProgram': { descriptions: ['Substance Abuse Program'] },
    'soc.WicClinic': { descriptions: ['WIC Clinic'] },
    'soc.withinReachFamilyHealthHotline': {
        descriptions: ['WithinReach Family Health Hotline']
    },
    'soc.CasaGuardianAdLitem': { descriptions: ['CASA / Guardian Ad Litem'] }
};
//# sourceMappingURL=Roles.js.map